app.factory("CalendarEventsService", ["$http",
    function ($http) {
        var CalendarEventsService = {};

        CalendarEventsService.list = function (params) {
            return $http.get("/calendar-event/list", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 10,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        CalendarEventsService.getById = function (params) {
            return $http.get("/calendar-event/one/" + params.id).then(function (resp) {
                return resp.data;
            })
        };

        CalendarEventsService.edit = function (params) {
            return $http.post("/calendar-event/edit", {
                _id: params._id,
                faculties: params.faculties,
                title: params.title,
                description: params.description,
                time: new Date(params.time)
            }).then(function (resp) {
                return resp.data;
            });
        };

        CalendarEventsService.remove = function (params) {
            return $http.post("/calendar-event/remove", {_id: params._id}).then(function (resp) {
                return resp.data;
            });
        };

        CalendarEventsService.add = function (params) {
            return $http.post("/calendar-event/add", {
                faculties: params.faculties,
                title: params.title,
                description: params.description,
                time: params.time
            });
        };

        return CalendarEventsService;
    }
]);